var SCM = SCM || {};

// Toggles .im-too-tall on .info-widget-wrap when its content overflows.
// The class is used by the content-nav SCSS to render a persistent scrollbar
// indicator; without it the scrollbar thumb stays transparent at rest and
// users have no visual cue that the sidebar scrolls.
(function (ns, $) {

    ns.refreshInfoWidgetOverflow = function () {
        $('.info-widget-wrap').each(function () {
            var el = this;
            if (el.scrollHeight > el.clientHeight) {
                el.classList.add('im-too-tall');
            } else {
                el.classList.remove('im-too-tall');
            }
        });
    };

    $(function () {
        ns.refreshInfoWidgetOverflow();
    });

    $(window).on('resize', debounce(ns.refreshInfoWidgetOverflow, 250));

    // Selecting a facet replaces the filter sidebar via AJAX, so the new
    // .info-widget-wrap needs its overflow re-evaluated. Other widgets use the
    // same global ajaxComplete hook to re-initialize after results update.
    $(document).ajaxComplete(function () {
        ns.refreshInfoWidgetOverflow();
    });

})(SCM.SiteJS = SCM.SiteJS || {}, jQuery);
